<style>
button.dt-button,
div.dt-button,
a.dt-button,
input.dt-button {
  color: white;
  background-color: green;
}

button.dt-button:hover:not(.disabled),
div.dt-button:hover:not(.disabled),
a.dt-button:hover:not(.disabled),
input.dt-button:hover:not(.disabled) {
  background-color: rgb(127, 238, 127);
}

.remove-button {
  margin-left: 10px;
}

#nonberusahaPTSA_info,
#nonberusahaPTSA_paginate,
#nonberusahaPTSA_filter {
  display: none;
}
</style>
<template>
  <div>
    <div v-if="show" :show="show" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>
    </div>
    <div v-if="!show">
      <div class="d-flex justify-content-between">
        <div>
          <button type="button" class="btn btn-success" @click="exportData">
            <i class="fa fa-file-text-o"></i> Excel
          </button>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mr-2 mb-0">Search: </label>
              <input v-model="search.value" type="text" class="form-control" id="search" />
            </div>
            <div>
              <select v-model="search.field" class="form-control">
                <option value="nomor_permohonan">Nomor Pemohon</option>
                <option value="instansi_pemohon">Instansi Pemohon</option>
                <option value="jenis_kegiatan">Jenis Kegiatan</option>
                <option value="provinsi">Provinsi</option>
                <option value="tanggal_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_ttd_mkp">Tgl. Penerbitan</option>
                <option value="nomor_kkp">No. Izin Terbit</option>
                <option value="pic_name">PIC Pentek</option>
              </select>
            </div>
          </div>
          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mb-0">Sort By: </label>
            </div>
            <div>
              <select v-model="sort.field" class="form-control">
                <option value="createdAt">Tgl. Dibuat</option>
                <option value="tanggal_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_ttd_mkp">Tgl. Penerbitan</option>
              </select>
            </div>
            <div class="ml-2">
              <select v-model="sort.direction" class="form-control">
                <option value="DESC">DESC</option>
                <option value="ASC">ASC</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table id="nonberusahaPTSA" class="table" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Nomor Pemohon</th>
              <th>Instansi Pemohon</th>
              <th>Jenis Kegiatan</th>
              <th>Provinsi</th>
              <th>Tgl. Permohonan</th>
              <th>Tgl. Penerbitan</th>
              <th>No. Izin Terbit</th>
              <th>PIC Pentek</th>
              <th>Unduh File</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in dataPermohonan" :key="index" :class="[
              {
                'row-perbaikan':
                  data.keterangan_status === 'Perbaikan Persyaratan',
              },
            ]">
              <!-- No -->
              <td>{{ index + pagination.firstInPage }}</td>
              <!-- Nomor Pemohon -->
              <td>
                <span class="badge rounded-pill bg-success" style="font-size: 10px; font-weight: normal"
                  v-if="data.nomor_permohonan != null">{{ data.nomor_permohonan }}</span>
                <span class="badge rounded-pill bg-danger" style="
                    font-size: 10px;
                    font-weight: normal;
                    background-color: #ff6e7c !important;
                  " v-else>Belum Ada</span>
              </td>
              <!-- Instansi Pemohon -->
              <td style="
                  word-wrap: break-word;
                  min-width: 200px;
                  max-width: 200px;
                  white-space: normal;
                ">
                {{ data.instansi_pemohon }}
              </td>
              <!-- Jenis Kegiatan -->
              <td style="
                  word-wrap: break-word;
                  min-width: 200px;
                  max-width: 200px;
                  white-space: normal;
                ">
                {{ data.jenis_kegiatan }}
              </td>
              <!-- Provinsi -->
              <td>{{ data.provinsi }}</td>
              <!-- Tgl. Permohonan -->
              <td>
                {{ format_date(data.tanggal_permohonan, 'DD MMMM YYYY') }}
              </td>
              <!-- Tgl. Penerbitan -->
              <td>
                {{ format_date(data.tanggal_ttd_mkp, 'DD MMMM YYYY') }}
              </td>
              <!-- No. Izin Terbit -->
              <td>
                {{ data.nomor_kkp }}
              </td>
              <!-- PIC Pentek -->
              <td>
                {{ data.pic_name }}
              </td>
              <!-- Unduh File -->
              <td>
                <div style="width: 250px">
                  <div class="row">
                    <div class="col-md-8">
                      <select v-model="data.selectedFile" style="width: 150px; margin-right: 10px" class="form-select"
                        aria-label="Default select example">
                        <option disabled value="">- Pilih File -</option>
                        <option value="verdok" :disabled="data.file_ba_verdok == null">
                          Verdok
                        </option>

                        <!-- Option File Tagihan -->
                        <option value="tagihan_1" :disabled="data.file_tagihan_i == null">
                          <i class="la la-edit"></i> Tagihan 1
                        </option>

                        <option value="tagihan_2" :disabled="data.file_tagihan_ii == null">
                          <i class="la la-edit"></i> Tagihan 2
                        </option>

                        <option value="tagihan_3" :disabled="data.file_tagihan_iii == null">
                          <i class="la la-edit"></i> Tagihan 3
                        </option>


                        <option value="pembayaran" :disabled="data.bukti_pembayaran == null">
                          Bukti Pembayaran
                        </option>
                        <option value="surattugas" :disabled="data.filename_final_surat_tugas == null &&
                          data.filename_konsep_surat_tugas == null
                          ">
                          Surat Tugas
                        </option>
                        <option value="undangan" :disabled="data.filename_final_undangan == null &&
                          data.filename_konsep_undangan == null
                          ">
                          Undangan
                        </option>
                        <option value="ba" :disabled="data.file_ba_vertek == null">
                          Berita Acara
                        </option>
                        <!-- <option
                        value="memo"
                        :disabled="
                          data.file_final_memorandum == null &&
                          data.file_konsep_memorandum == null
                        "
                      >
                        Memorendum
                      </option> -->
                        <option value="shp" :disabled="data.file_shp == null">
                          File SHP
                        </option>

                        <option value="resume" :disabled="data.file_resume_permohonan == null &&
                          data.file_resume_permohonan == null
                          ">
                          Resume Permohonan
                        </option>

                        <option value="persetujuan" :disabled="data.file_persetujuan == null">
                          Surat Persetujuan
                        </option>

                        <!-- <option
                        value="final-persetujuan"
                        :disabled="data.file_izin_ttd == null"
                      >
                        Final Surat Persetujuan
                      </option> -->
                      </select>
                    </div>
                    <div class="col-md-4 mt-2">
                      <span v-if="
                        data.file_resume_permohonan != null &&
                        data.selectedFile == 'resume'
                      ">
                        <a :href="data.file_resume_permohonan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file resume permohonan" />
                        </a>
                      </span>

                      <span v-if="
                        data.file_shp != null && data.selectedFile == 'shp'
                      ">
                        <a :href="data.file_shp" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top" title="Unduh file SHP" />
                        </a>
                      </span>

                      <span v-if="
                        data.file_ba_verdok != null &&
                        data.selectedFile == 'verdok'
                      ">
                        <a :href="data.file_ba_verdok" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file verifikasi dokumen" /></a>
                      </span>

                      <!-- Download File Tagihan -->
                      <span v-if="
                        data.file_tagihan_iii != null &&
                        data.selectedFile == 'tagihan_3'
                      ">
                        <a :href="data.file_tagihan_iii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 3" /></a>
                      </span>
                      <span v-if="
                        data.file_tagihan_ii != null &&
                        data.selectedFile == 'tagihan_2'
                      ">
                        <a :href="data.file_tagihan_ii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 2" />
                        </a>
                      </span>

                      <span v-if="
                        data.file_tagihan_i != null &&
                        data.selectedFile == 'tagihan_1'
                      ">
                        <a :href="data.file_tagihan_i" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 1" /></a>
                      </span>


                      <!-- <br> -->
                      <span v-if="
                        data.bukti_pembayaran != null &&
                        data.selectedFile == 'pembayaran'
                      ">
                        <a :href="data.bukti_pembayaran" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file bukti pembayaran" />
                        </a>
                      </span>

                      <span v-if="
                        data.filename_final_surat_tugas != null &&
                        data.selectedFile == 'surattugas'
                      ">
                        <a :href="data.filename_final_surat_tugas" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file surat tugas" /></a>
                      </span>
                      <span v-else-if="
                        data.filename_konsep_surat_tugas != null &&
                        data.selectedFile == 'surattugas'
                      ">
                        <a :href="data.filename_konsep_surat_tugas" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file surat tugas" /></a>
                      </span>

                      <span v-if="
                        data.filename_final_undangan != null &&
                        data.selectedFile == 'undangan'
                      ">
                        <a :href="data.filename_final_undangan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file undangan" /></a>
                      </span>
                      <span v-else-if="
                        data.filename_konsep_undangan != null &&
                        data.selectedFile == 'undangan'
                      ">
                        <a :href="data.filename_konsep_undangan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file undangan" /></a>
                      </span>

                      <span v-if="
                        data.file_ba_vertek != null &&
                        data.selectedFile == 'ba'
                      ">
                        <a :href="data.file_ba_vertek" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file berita acara" /></a>
                      </span>

                      <span v-if="
                        data.file_final_memorandum != null &&
                        data.selectedFile == 'memo'
                      ">
                        <a :href="data.file_final_memorandum" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file memo" /></a>
                      </span>
                      <span v-else-if="
                        data.file_konsep_memorandum != null &&
                        data.selectedFile == 'memo'
                      ">
                        <a :href="data.file_konsep_memorandum" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file memo" /></a>
                      </span>

                      <span v-if="
                        data.file_persetujuan != null &&
                        data.selectedFile == 'persetujuan'
                      ">
                        <a :href="data.file_persetujuan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan" />
                        </a>
                      </span>

                      <span v-if="
                        data.file_izin_ttd != null &&
                        data.selectedFile == 'final-persetujuan'
                      ">
                        <a :href="data.file_izin_ttd" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan" />
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- Aksi -->
              <td>
                <div style="width: 200px">
                  <b-button-toolbar>
                    <b-button size="sm" variant="info" @click="
                      $router.push(
                        '/app/nonberusaha/detail-perizinan/' + data.id,
                      )
                      " class="text-white m-1"><i class="fa fa-eye" /> Detail</b-button>
                    <b-button size="sm" variant="warning" @click="showModalRekomendasi(data)" class="text-white m-1">
                      <i class="fa fa-pencil-square-o"></i> Buat Rekomendasi
                    </b-button>
                    <b-button size="sm" variant="primary" class="text-white m-1" @click="sendReminder(data)">
                      <i class="fa fa-envelope-o"></i> Kirim Pengingat
                    </b-button>
                  </b-button-toolbar>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai
            {{
              pagination.currentPage !== pagination.lastPage
                ? pagination.limit * pagination.currentPage
                : pagination.total
            }}
            dari {{ pagination.total }} data
          </template>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li :class="['page-item', { disabled: pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'first' })">
                <span aria-hidden="true">Awal</span>
              </a>
            </li>
            <li :class="['page-item', { disabled: pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'prev' })">
                <span aria-hidden="true">Sebelumnya</span>
              </a>
            </li>
            <li v-for="i in pagination.pageNumber" class="page-item">
              <a :class="[
                'page-link',
                { active: i === `${pagination.currentPage}` },
              ]" href="#" @click="changePage({ page: i })">{{ i }}</a>
            </li>
            <li :class="[
              'page-item',
              { disabled: pagination.currentPage === pagination.lastPage },
            ]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'next' })">
                <span aria-hidden="true">Selanjutnya</span>
              </a>
            </li>
            <li :class="[
              'page-item',
              { disabled: pagination.currentPage === pagination.lastPage },
            ]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'last' })">
                <span aria-hidden="true">Akhir</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <b-modal id="modal-rekomendasi" title="Buat Rekomendasi" size="md">
      <template>
        <b-form>
          <div class="row g-0">
            <div class="col-12">
              <label for="jenis_rekomendasi">
                Jenis Rekomendasi <span class="text-danger">*</span>
              </label>
              <v-select id="jenis_rekomendasi" v-model="formRekomendasi.jenis_rekomendasi"
                :options="['Habis Masa Berlaku', 'Pencabutan', 'Pembatalan']" name="Jenis Rekomendasi"
                v-validate="'required'" />
              <span class="text-danger" v-if="errors.has('Jenis Rekomendasi')">
                {{ errors.first('Jenis Rekomendasi') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label for="file_rekomendasi">
                <template v-if="
                  formRekomendasi.jenis_rekomendasi === 'Habis Masa Berlaku'
                ">
                  File Rekomendasi Habis Masa Berlaku
                </template>
                <template v-if="formRekomendasi.jenis_rekomendasi === 'Pencabutan'">
                  File Rekomendasi Pencabutan
                </template>
                <template v-if="formRekomendasi.jenis_rekomendasi === 'Pembatalan'">
                  File Rekomendasi Pembatalan
                </template>
                <span class="text-danger">*</span>
              </label>
              <InputFile id="file_rekomendasi" v-model="formRekomendasi.file_rekomendasi" name="File Rekomendasi"
                accept=".pdf" v-validate="'required'" />
              <span class="text-danger" v-if="errors.has('File Rekomendasi')">
                {{ errors.first('File Rekomendasi') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label for="nomor_surat_permohonan">
                Nomor Surat <span class="text-danger">*</span>
              </label>
              <b-form-input id="nomor_surat_permohonan" v-model="formRekomendasi.nomor_surat_permohonan"
                v-validate="'required'" name="Nomor Surat"></b-form-input>
              <span class="text-danger" v-if="errors.has('Nomor Surat')">
                {{ errors.first('Nomor Surat') }}
              </span>
            </div>
            <div v-if="formRekomendasi.jenis_rekomendasi === 'Pembatalan'" class="col-12 mt-3">
              <label for="perihal_surat_permohonan">
                Perihal Surat <span class="text-danger">*</span>
              </label>
              <b-form-input id="perihal_surat_permohonan" v-model="formRekomendasi.perihal_surat_permohonan"
                v-validate="'required'" name="Perihal Surat"></b-form-input>
              <span class="text-danger" v-if="errors.has('Perihal Surat')">
                {{ errors.first('Perihal Surat') }}
              </span>
            </div>
            <div class="col-lg-12 mt-3">
              <label for="tanggal_surat_permohonan">
                Tanggal Surat <span class="text-danger">*</span>
              </label>
              <b-form-input type="date" id="tanggal_surat_permohonan" v-model="formRekomendasi.tanggal_surat_permohonan"
                v-validate="'required'" name="Tanggal Surat"></b-form-input>
              <span class="text-danger" v-if="errors.has('Tanggal Surat')">
                {{ errors.first('Tanggal Surat') }}
              </span>
            </div>
          </div>
        </b-form>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" size="sm" class="float-right" @click="submitRekomendasi" :disabled="isLoading">
            <img src="@/assets/icons/archive.svg" />
            Simpan
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import moment from 'moment'
import axios from 'axios'
import vSelect from 'vue-select'
import Swal from 'sweetalert2'
import VueLoading from 'vuejs-loading-plugin'
import * as xlsx from 'xlsx'
import InputFile from '../../Components/InputFile.vue'
import dayjs from 'dayjs'

// using default options
Vue.use(VueLoading)

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Loading', // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: 'rgb(255,255,255)', // set custom background
  classes: ['myclass'], // array, object or string
})
export default {
  components: { vSelect, InputFile },
  data() {
    return {
      fields: [
        'no',
        { key: 'nama_pemohon', sortable: true },
        { key: 'nomor_permohonan', sortable: true },
        { key: 'jenis_kegiatan', sortable: true },
        { key: 'status_verdok', label: 'Status', sortable: true },
        { key: 'tanggal_pada_permohonan', label: 'Tanggal Permohonan' },
        { key: 'file_undangan', label: 'Undangan Pentek' },
        'Aksi',
      ],

      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'name',
      sortDesc: false,
      wygEditor: ClassicEditor,
      dataSuratTugas: [],
      dataUser: [],
      dataTTD: [],
      id_Permohonan: null,
      dataCatatanSurat: [],
      detailCatatan: [],
      dataPerDokumen: [],
      dataUndangan: [],
      dataCatatanUndangan: [],
      detailCatatanUndangan: [],
      dataUserPIC: [],
      dataUserPICMonitor: [],

      isLoading: false,
      formRekomendasi: {
        jenis_rekomendasi: 'Habis Masa Berlaku',
        file_rekomendasi: null,
        nomor_surat_permohonan: null,
        perihal_surat_permohonan: null,
        tanggal_surat_permohonan: null,
      },

      popoverShow: {},
      dataPermohonan: [],

      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: 'nomor_permohonan',
        value: '',
      },
      sort: {
        field: 'tanggal_permohonan',
        direction: 'DESC',
      },
      debounceTerm: null,
      show: false,
    }
  },
  props: {
    tipe: String,
    user: Object,
    baseapi: String,
  },
  mounted() {
    this.getdata()
  },
  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getdata()
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getdata()
      },
      deep: true,
    },
  },
  methods: {
    format_date(value, format = 'DD MMMM YYYY') {
      if (value) {
        return dayjs(value).format(format)
      }
    },

    initDatatable2() {
      setTimeout(() => {
        var t = '#example2'.DataTable({
          pagingType: 'full_numbers',
          language: {
            info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
            paginate: {
              first: 'Awal',
              last: 'Akhir',
              next: 'Selanjutnya',
              previous: 'Sebelumnya',
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 2,
            right: 1,
          },
          scrollX: true,
        })
        t.on('order.dt search.dt', function () {
          t.column(0, { search: 'applied', order: 'applied' })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1
            })
        }).draw()
      }, 300)
    },

    initDatatable3() {
      setTimeout(() => {
        var t = $('#example3').DataTable({
          pagingType: 'full_numbers',
          language: {
            info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
            paginate: {
              first: 'Awal',
              last: 'Akhir',
              next: 'Selanjutnya',
              previous: 'Sebelumnya',
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 2,
            right: 1,
          },
          scrollX: true,
        })
        t.on('order.dt search.dt', function () {
          t.column(0, { search: 'applied', order: 'applied' })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1
            })
        }).draw()
      }, 300)
    },

    getdata() {
      $('#nonberusahaPTSA').DataTable().destroy()
      this.loaddata()
    },

    loaddata() {
      this.show = true
      this.dataPermohonan = []
      // prettier-ignore
      const api = `api/permohonan_nonberusaha/dataTable` +
        `?page=${this.pagination.currentPage}` +
        `&filter=tipe_pemohon,=,${this.tipe};keterangan_status,=,Terbit` +
        `${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_permohonan' || this.search.field === 'tanggal_ttd_mkp' ? '>=' : 'like'},${this.search.value}` : ''}` +
        `&sort=${this.sort.field},${this.sort.direction}`
      axios
        .get(this.baseapi + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          const data = response.data
          this.pagination.limit = data.limit
          this.pagination.total = data.total
          this.pagination.firstInPage =
            (this.pagination.currentPage - 1) * data.limit + 1
          this.pagination.lastPage = Math.ceil(data.total / data.limit)
          this.setPagination()
          this.dataPermohonan = response.data.data

          for (let index = 0; index < this.dataPermohonan.length; index++) {
            Vue.set(this.dataPermohonan[index], 'selectedFile', null)
          }
          this.initDatatable()
        })
        .catch((error) => {
          console.log(error)
          return error
        })
        .finally(() => {
          this.show = false
        })
    },

    showModalRekomendasi(record) {
      this.selectedData = record
      this.$bvModal.show('modal-rekomendasi')
    },

    async submitRekomendasi() {
      this.$validator.validateAll().then(async (res) => {
        if (res) {
          this.$loading(true)
          this.isLoading = true
          const {
            instansi_pemohon,
            nomor_kkp,
            tanggal_ttd_mkp,
            masa_berlaku,
            npwp_pemohon,
            nomor_permohonan,
          } = this.selectedData
          const {
            jenis_rekomendasi,
            file_rekomendasi,
            nomor_surat_permohonan,
            perihal_surat_permohonan,
            tanggal_surat_permohonan,
          } = this.formRekomendasi

          const formData = new FormData()

          // prettier-ignore
          if (jenis_rekomendasi === 'Pembatalan') {
            formData.append('file_permohonan_pemuktahiran', file_rekomendasi)
            formData.append('nomor_surat_permohonan', nomor_surat_permohonan)
            formData.append('perihal_surat_permohonan', perihal_surat_permohonan)
            formData.append('tanggal_surat_permohonan', tanggal_surat_permohonan)
            formData.append('jenis_pemuktahiran', 'Pengembalian')
            formData.append('jenis_permohonan', 'Nonberusaha')
            formData.append('nomor_izin_terbit', nomor_kkp)
            formData.append('instansi_pemohon', instansi_pemohon)
            formData.append('npwp', npwp_pemohon)
            formData.append('nomor_permohonan', nomor_permohonan)
            formData.append('tanggal_penerbitan_izin', tanggal_ttd_mkp)
            formData.append('status_persetujuan', 'Terima')
            formData.append('status', 'Menunggu Jadwal Penilaian')
          } else {
            formData.append('jenis_permohonan', 'Nonberusaha')
            formData.append('nama_pemohon', instansi_pemohon)
            formData.append('nomor_izin_terbit', nomor_kkp)
            formData.append('tanggal_penerbitan', tanggal_ttd_mkp)
            formData.append('masa_berlaku', masa_berlaku)
            formData.append('nomor_surat_permohonan', nomor_surat_permohonan)
            formData.append('tanggal_surat_permohonan', tanggal_surat_permohonan)
            formData.append('status', 'Menunggu Jadwal Penilaian')
            if (jenis_rekomendasi === 'Habis Masa Berlaku') {
              formData.append('file_rekomendasi_habis_masa_berlaku', file_rekomendasi)
            } else {
              formData.append('file_rekomendasi_pencabutan', file_rekomendasi)
            }
          }

          let api = ''
          switch (jenis_rekomendasi) {
            case 'Habis Masa Berlaku':
              api = 'api/habis_masa_berlaku'
              break
            case 'Pencabutan':
              api = 'api/pencabutan'
              break
            case 'Pembatalan':
              api = 'api/pemuktahiran'
              break
          }

          try {
            await axios.post(this.baseapi + api, formData, this.getApiOption())
            this.$bvModal.hide('modal-rekomendasi')
            Swal.fire('Berhasil', 'Berhasil membuat rekomendasi', 'success')
          } catch (error) {
            Swal.fire('Gagal', 'Gagal membuat rekomendasi', 'error')
          } finally {
            this.$loading(false)
            this.isLoading = false
          }
        }
      })
    },

    async sendReminder(record) {
      const { id, nama_pemohon, nomor_oss } = record
      const confirm = await Swal.fire({
        title: 'Kirim Email Pengingat',
        text: `Kirim email pengingat untuk Pemohon ${nama_pemohon} dengan Nomor Penerbitan ${nomor_oss}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, kirim',
        cancelButtonText: 'Batal',
      })
      if (!confirm.isConfirmed) return
      try {
        await axios.post(
          `${this.baseapi}api/permohonan_nonberusaha/sendReminder`,
          { id },
          this.getApiOption(),
        )
        Swal.fire('Berhasil', 'Email pengingat berhasil dikirim', 'success')
      } catch (error) {
        Swal.fire('Gagal', 'Email pengingat gagal dikirim', 'error')
      }
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch((err) => { })
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (
          this.pagination.currentPage >=
          this.pagination.lastPage - 2
        ) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment('DD MMMM YYYY')

        var t = $('#nonberusahaPTSA').DataTable({
          pagingType: 'full_numbers',
          language: {
            info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
            paginate: {
              first: 'Awal',
              last: 'Akhir',
              next: 'Selanjutnya',
              previous: 'Sebelumnya',
            },
          },
          // stateSave: true,
          // order: [[8, "desc"]],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 3, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // console.log(meta.row);
                // console.log(type == 'export' ? meta.row : data);
                return type == 'export' ? meta.row + 1 : data
              },
              rowCallback: function (row, data, index) {
                console.log(data)
                if (data[0] == 'OK') {
                  $(row).addClass('green')
                } else if (data[0] == 'Before') {
                  $(row).addClass('orange')
                }
              },
            },
          ],
          buttons: [],
        })
      }, 300)
    },

    exportData() {
      this.$loading(true)
      // prettier-ignore
      const api = `api/permohonan_nonberusaha` +
        `?sort=${this.sort.field},${this.sort.direction}` +
        `&filter=tipe_pemohon,=,${this.tipe};keterangan_status,=,Terbit` +
        `${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_permohonan' || this.search.field === 'tanggal_ttd_mkp' ? '>=' : 'like'},${this.search.value}` : ''}`
      axios
        .get(this.baseapi + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          const worksheetData = [
            ['Data Pemohon'],
            [
              'No',
              'Nomor Pemohon',
              'Instansi Pemohon',
              'Jenis Kegiatan',
              'Provinsi',
              'Tgl. Permohonan',
              'Tgl. Penerbitan',
              'No. Izin Terbit',
              'PIC Pentek',
            ],
          ]
          const merge = [
            { s: { c: 0, r: 0 }, e: { c: worksheetData[1].length - 1, r: 0 } },
          ]
          res.data.data.map((d, i) => {
            worksheetData.push([
              i + 1,
              d.nomor_permohonan,
              d.instansi_pemohon,
              d.jenis_kegiatan,
              d.provinsi,
              d.tanggal_permohonan,
              d.tanggal_ttd_mkp,
              d.nomor_kkp,
              d.pic_name,
            ])
          })

          const workbook = xlsx.utils.book_new()
          const worksheet = xlsx.utils.aoa_to_sheet(worksheetData)
          worksheet['!merges'] = merge
          xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
          const d = new Date()
          xlsx.writeFile(
            workbook,
            `Data Pemohon ${d.getFullYear()}-${d.getMonth() + 1
            }-${d.getDate()}.xlsx`,
          )
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
}
</script>
